import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

export const useToleranceChanges = (operationId: string, enabled: boolean) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.toleranceChanges(operationId),
    queryFn: () => drybulkCargoOperationsService.toleranceChanges(operationId),
    enabled,
    retry: false,
    staleTime: 0,
  });
